interface DirectionsProps {
  stopLat: number
  stopLng: number
  stopName: string
  lang: 'el' | 'en'
}

export function Directions({ stopLat, stopLng, lang }: DirectionsProps) {
  const t = {
    getDirections: lang === 'el' ? 'Οδηγίες' : 'Directions',
  }

  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${stopLat},${stopLng}&travelmode=walking`
  const appleMapsUrl = `https://maps.apple.com/?daddr=${stopLat},${stopLng}&dirflg=w`

  return (
    <div className="directions-container">
      <div className="directions-header">
        <span className="directions-title">📍 {t.getDirections}</span>
      </div>
      <div className="directions-buttons">
        <a
          href={googleMapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="directions-btn google"
        >
          <img
            src="https://www.google.com/s2/favicons?domain=maps.google.com&sz=32"
            alt="Google Maps"
            className="directions-logo"
          />
          <span>Google Maps</span>
        </a>
        <a
          href={appleMapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="directions-btn apple"
        >
          <img
            src="https://www.google.com/s2/favicons?domain=maps.apple.com&sz=32"
            alt="Apple Maps"
            className="directions-logo"
          />
          <span>Apple Maps</span>
        </a>
      </div>
    </div>
  )
}
